interface HasIcon {
  id: string;
  image: string;
}

export const userIcon = (user: HasIcon | undefined) =>
  user?.image ||
  `https://cdn.discordapp.com/embed/avatars/${(BigInt(user?.id || "0") >> 22n) % 6n}.png`;
